import React from 'react';
import Footer from './Footer';
import axios from 'axios';
import { object, string, number } from 'yup';

function PlaywrightRegister() {
  let initialState = {
    name: '',
    email: '',
    phone: '',
    courses: '--',
  };

  const [formData, setFormData] = React.useState(initialState);
  const [showAlert, setShowAlert] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  let schema = object().shape({
    name: string().required(),
    email: string().email().required(),
    phone: number().required(),
    courses: string()
      .test('is-valid', 'Please select a course', (value) => value !== '--')
      .required(),
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    setFormData(initialState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await schema.validate(formData);
    } catch (error) {
      return alert(error.message);
    }
    setIsLoading(true);
    await axios
      .post('https://appendgooglesheet-rao5lvirzq-uc.a.run.app', formData)
      .then(() => {
        setShowAlert(true);
        handleReset();
        setIsLoading(false);
      });
  };

  return (
    <div style={{ margin: '190px 0px 0px 0px' }}>
      <div className="row align-items-start" id="contactMe">
        <div
          style={{ padding: '0 60px 0 0' }}
          className="col-sm-6"
          id="contactText"
        >
          <h1 className="text-info" style={{ fontSize: '44px' }}>
            Rest Assured with Java
          </h1>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Course Objectives
          </h2>
          <p style={{ fontSize: '15px' }}>
            The Rest Assured with Java course is designed to provide
            participants with a comprehensive understanding of API testing using
            Rest Assured, a powerful Java library for testing RESTful APIs. The
            course covers the fundamentals of API testing, including how to
            create, send, and validate HTTP requests and responses. Participants
            will learn how to write effective test cases for RESTful APIs,
            handle authentication, and manage test data. By the end of the course, participants will be
            equipped with the skills to design, implement, and maintain robust
            automated tests for RESTful APIs using Rest Assured with Java.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Who will benefit?
          </h2>
          <p style={{ fontSize: '15px' }}>
            This course is ideal for software testers, developers, and
            quality assurance professionals who want to enhance their skills in
            API testing. It is also suitable for those looking to transition
            into a test automation role or improve their existing automation
            skills. Whether you are a beginner or have some experience in API
            testing, this course will provide you with the knowledge and tools
            needed to excel in test automation.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Prerequisites
          </h2>
          <p style={{ fontSize: '15px' }}>
            Basic knowledge of computers and a willingness to learn programming.
            No prior programming experience required.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Skills Gained & Benefits
          </h2>
          <ul className={'list-group'}>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Comprehensive understanding of test automation concepts and
              techniques
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Expertise in Rest Assured with Java for API testing
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Hands-on experience in building automated testing solutions
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Knowledge of best practices and strategies in test automation
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Hands-on experience in integrating test automation with CI/CD
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              3 months access to private github repository with code samples,
              exercises, solutions and course materials
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              3 months access to private one on one mentoring sessions with
              Rest Assured Java experts
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              24 months access to private Google Chat space for Rest Assured technical support
            </li>
          </ul>
        </div>
        <div className="col-sm-6">
          {showAlert && (
            <div className="alert alert-success" role="alert">
              Registration Successful, we will contact you soon!
            </div>
          )}
          <form className="mt-4" method="POST" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="Number" className="form-label">
                Phone Number
              </label>
              <input
                className="form-control"
                id="Number"
                name="phone"
                value={formData.phone}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor={'courses'} className={'form-label'}>
                Course Start Date & Fee
              </label>
              <select
                className="form-select"
                id="courses"
                name="courses"
                value={formData.courses}
                required
                onChange={handleChange}
              >
                <option value="--" disabled>
                  --
                </option>
                <option value={'Rest Assured Mastery Course August 23rd 2025'}>
                  September 27th 2025 -- £250
                </option>
                <option
                  value={'Rest Assured Mastery Course October 18th 2025'}
                >
                  November 15th 2025 -- £250
                </option>
              </select>
            </div>
            <button type="submit" className="btn btn-info" disabled={isLoading}>
              Register
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PlaywrightRegister;
